import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';

import Link from 'next/link';
import TagManager from 'react-gtm-module';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import ChatBotContainer from 'components/chatbot/ChatBotContainer';
import LayoutContainer from 'components/layout/LayoutContainer';
import { Breadcrumbs } from 'components/widgets';
import { SupportButton } from 'components/utils/SupportButton';
import faqs from '../../src/components/faqs/faqsDoc';

const question23 = React.createRef();
const question7 = React.createRef();

const domain = process.env.REACT_APP_BASE_PATH_FILES;

const FaqsPage = () => {
	const router = useRouter();
	const canonicalURL =
		process.env.REACT_APP_DOMAIN_URL + (router?.asPath || router?.pathname);

	const [expanded, setExpanded] = useState(null);
	const routes = [
		{
			name: 'Inicio',
			pathname: '/',
			asPath: '/'
		},
		{
			name: 'Preguntas frecuentes',
			pathname: router?.pathname,
			asPath: router?.asPath
		}
	];

	useEffect(() => {
		checkQuestionScroll();
		const tagManagerArgs = {
			dataLayer: {
				event: 'pageview',
				pageTitle:
					'Preguntas frecuentes sobre nuestro seguro para emergencias médicas'
			}
		};
		TagManager.dataLayer(tagManagerArgs);
	}, []);

	const checkQuestionScroll = () => {
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop)
		});
		if (params.q) {
			const el =
				document.querySelectorAll('.MuiAccordion-root')[params.q - 1]
					?.children[0];
			el?.click();
			el?.scrollIntoView({ block: 'center' });
		}
	};

	const handleChange = (panel) => (value) => {
		setExpanded(value && expanded !== panel ? panel : null);
	};

	return (
		<LayoutContainer>
			<div className="content background-content">
				<Head>
					<title>
						Preguntas frecuentes sobre nuestro seguro para emergencias médicas
					</title>
					<meta
						name="description"
						content="Todas las respuestas que necesitas saber antes de asegurar a tu familia con asistensi, el mejor seguro para emergencias médicas"
					/>
					<link rel="canonical" href={canonicalURL} />
				</Head>

				<div className="mt-24">
					<Breadcrumbs routes={routes} />
				</div>

				<div className="h-full">
					<div className="container">
						<div className="flex flex-col justify-between md:flex-row">
							<div className="flex flex-col items-center justify-center py-4">
								<h2 className="mb-4 text-base font-bold text-center text-pink-500 font-poppins">
									Todo lo que debes saber para asegurar a los tuyos
								</h2>
								<h1 className="text-4xl font-bold leading-snug text-center text-purple-500 font-poppins">
									Preguntas frecuentes
								</h1>
							</div>
							{/* <SupportButton isFaq={true}/> */}
						</div>
					</div>

					<div className="container">
						{faqs.map(({ title, questions }) => (
							<>
								<p className="my-6 mr-4 text-2xl font-bold text-purple-500 font-poppins">
									{title}
								</p>
								{questions.map(({ number, question, answer }) => (
									<Accordion
										expanded={expanded === number}
										onChange={handleChange(number)}
										key={number}
									>
										<AccordionSummary
											expandIcon={
												<ExpandMoreIcon
													style={
														expanded === number ? { color: '#fb314a' } : null
													}
												/>
											}
										>
											<div>
												<span
													className={`text-base text-pink-500 mr-2 ${
														expanded === number ? 'font-bold' : ''
													}`}
												>
													{number}.
												</span>
												<span
													className={`text-base text-gray-800 ${
														expanded === number ? 'font-bold' : ''
													}`}
												>
													{question}
												</span>
											</div>
										</AccordionSummary>
										<AccordionDetails
											classes={{ root: 'pt-2 pb-6 bg-gray-100' }}
										>
											<div className="flex flex-col px-2">{answer}</div>
										</AccordionDetails>
									</Accordion>
								))}
							</>
						))}
					</div>

					<div className="container flex justify-center align-center mt-14 mb-14">
						<Link href="/contact" as="/contacto">
							<a className="secondary-button contact-button-faq">
								¡Contáctanos!
							</a>
						</Link>
					</div>
				</div>
			</div>
		</LayoutContainer>
	);
};

export default FaqsPage;
